import i18n from 'i18next';
import { useInitContext } from '../init/context';
import { createContext } from 'react';
import { getUserLanguage, i18nPromise, setUserLanguage } from './i18n';
import type { LanguageListKeys } from '@/configs/i18n';
import { languageList } from '@/configs/i18n';

export type I18nContextValue = ReturnType<typeof useI18nContextValue>;

export const i18nContext = createContext<I18nContextValue>({} as never);

export function useI18nContextValue() {
  const { pushInit } = useInitContext();
  const [language, setLanguage] = useState(getUserLanguage());

  const languageItem = useMemo(
    () =>
      languageList.findByKey(language as LanguageListKeys) ||
      languageList.findByKey('en')!,
    [language]
  );

  const setLanguage_ = useCallback<typeof i18n.changeLanguage>((lang, callback) => {
    setUserLanguage(lang);
    setLanguage(lang || getUserLanguage());
    return i18n.changeLanguage(lang, callback);
  }, []);

  const value = useMemo(
    () => ({ setLanguage: setLanguage_, language, languageItem, languageList }),
    [setLanguage_, language, languageItem]
  );

  useLayoutEffect(() => {
    pushInit(i18nPromise);
  }, [pushInit]);

  return value;
}

export function useI18nContext() {
  return useContext(i18nContext);
}
